// authActionTypes.js

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTRATION = "REGISTRATION";
export const SCANDATAURL = "SCANDATAURL";
export const ISSPINNED = "ISSPINNED"; 
export const GENUNITYSTATUSDATA = "GENUNITYSTATUSDATA";
export const MYREWARDS = "MYREWARDS";
export const CLAIMSTATUS = "CLAIMSTATUS";
export const CLAIMAMOUNT = "CLAIMAMOUNT";
export const RECLAIMDATA = "RECLAIMDATA";
export const  CROPDATA = "CROPDATA";
export const  GIFTURL = "GIFTURL";
export const  SET_SECONDARY_MESSAGE = "SET_SECONDARY_MESSAGE";


